import { useAILayer } from '../../aiLayers/hooks'

const DefaultAILabel = ({ ai }) => {
  const layer = useAILayer(ai.layerId)

  return ai.attributes[layer.labelField] || 'MISSING LABEL'
}

export default DefaultAILabel
